import { useState } from "react";

import { useLocation, useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import bizechoLogo from "../assets/images/bizecho-logo.png";
import { useAuth } from "../components/AuthProvider";
import { userData } from "../recoil/atom/userData";
import { Impersonate } from "./Impersonate";

function Header() {
  const { logout, isAuthenticated } = useAuth();
  const [user, setUser] = useRecoilState(userData);
  const navigate = useNavigate();
  // State to manage the mobile menu visibility
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen((prev) => !prev);
  };

  const location = useLocation();

  return (
    <header className="sticky-header max-full mx-auto px-6 py-6 flex items-center justify-between bg-gray-900 text-gray-100">
      <div className="flex items-center gap-3">
        <div className="w-12 h-12 rounded-xl bg-gradient-to-br  flex items-center justify-center shadow-lg">
          <img src={bizechoLogo} alt="Bizecho Logo" />
        </div>
        <div>
          <button onClick={() => navigate("/")} className="flex items-center">
            <span className="self-center text-xl font-semibold whitespace-nowrap dark:text-white">
              Bizecho
            </span>
          </button>
          <p className="text-xs text-gray-400">
            WhatsApp-first CRM for automobile companies
          </p>
        </div>
      </div>
      <nav className="hidden md:flex gap-8 items-center text-sm font-medium">
        <div className="flex items-center justify-between lg:order-2 dark">
          {location.pathname.includes("dashboard") && (
            <p className="text-white pe-3">Welcome, {user?.businessName} </p>
          )}
          {location.pathname.includes("dashboard") &&
          user &&
          user.isSuperAdmin ? (
            <Impersonate />
          ) : null}
          {isAuthenticated ? (
            <>
              <button
                onClick={() => {
                  setUser(null);
                  logout(navigate("/"));
                }}
                href="#home"
                className="btn block py-2 pl-3 pr-4"
              >
                Logout
              </button>
            </>
          ) : (
            window.location.pathname !== "/login" && (
              <div className="flex gap-3">
                <button
                  className="hidden md:inline-flex items-center px-4 py-2 rounded-md border border-gray-700 text-sm hover:border-teal-400 hover:text-teal-300 transition-all"
                  onClick={() => navigate("/login")}
                >
                  Log in
                </button>
                <button
                  onClick={() => navigate("/book-a-demo")}
                  className="inline-flex items-center gap-2 bg-gradient-to-r from-teal-400 to-cyan-400 text-gray-900 px-5 py-2 rounded-lg font-semibold shadow-lg hover:brightness-110 transition-all"
                >
                  Book a Demo
                </button>
              </div>
            )
          )}

          <button
            onClick={toggleMobileMenu}
            type="button"
            className="inline-flex items-center p-2 ml-1 text-sm text-gray-500 rounded-lg hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
            aria-expanded={isMobileMenuOpen}
          >
            <span className="sr-only">Open main menu</span>
            <svg
              className="w-6 h-6"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                clipRule="evenodd"
              ></path>
            </svg>
          </button>
        </div>

        {/* Navigation Links */}
        <div
          className={`items-center justify-between ${
            isMobileMenuOpen ? "block" : "hidden"
          } w-full lg:flex lg:w-auto lg:order-1`}
        >
          <ul className="flex flex-col mt-4 font-medium lg:flex-row lg:space-x-8 lg:mt-0">
            {isAuthenticated && !location.pathname.includes("dashboard") && (
              <>
                <li>
                  <button
                    onClick={() => navigate("/")}
                    className="block py-2 pl-3 pr-4 text-white rounded lg:bg-transparent lg:p-0 dark:text-white"
                  >
                    Home
                  </button>
                </li>

                {["Features", "AI Sales Agent", "Products", "FAQ"].map(
                  (item) => (
                    <li key={item}>
                      <a
                        href={
                          item === "AI Sales Agent"
                            ? "/ai-sales-agent"
                            : `/#${item.toLowerCase()}`
                        }
                        className="block py-2 pl-3 pr-4 text-white rounded lg:bg-transparent lg:p-0 dark:text-white"
                      >
                        {item}
                      </a>
                    </li>
                  ),
                )}
                <li>
                  <button
                    onClick={() => navigate("/blogs")}
                    className="block py-2 pl-3 pr-4 text-white rounded lg:bg-transparent lg:p-0 dark:text-white"
                  >
                    Blog
                  </button>
                </li>

                <li>
                  <button
                    onClick={() => navigate("/dashboard/sales")}
                    className="block py-2 pl-3 pr-4 text-white rounded lg:bg-transparent lg:p-0 dark:text-white"
                  >
                    Dashboard
                  </button>
                </li>
              </>
            )}

            {!isAuthenticated && window.location.pathname !== "/login" && (
              <>
                <nav className="hidden md:flex gap-8 items-center text-sm font-medium">
                  {[
                    "Features",
                    "AI Sales Agent",
                    "Products",
                    "Dashboard",
                    "FAQ",
                  ].map((item) => (
                    <a
                      key={item}
                      href={
                        item === "AI Sales Agent"
                          ? "/ai-sales-agent"
                          : `/#${item.toLowerCase()}`
                      }
                      className="text-gray-300 hover:text-teal-300 transition-colors"
                    >
                      {item}
                    </a>
                  ))}
                </nav>
              </>
            )}
          </ul>
        </div>
      </nav>
    </header>
  );
}

export default Header;
